import React from "react";
import Icon from "sulu-admin-bundle/components/Icon";

import {
    TIME_SUSPENSION_FOR_CARDS,
    ALLOWED_MINUTES_BY_CARD,
} from "../../components/LiveTicker/params";

const SuspensionTime = ({
    eventDetails,
    setEventDetails,
    changeCallback,
    confirmCallback,
}) => {
    const cardType = eventDetails?.type?.name;

    const suspensionOptions = TIME_SUSPENSION_FOR_CARDS.filter((tg) => {
        if (!cardType) return false;

        return ALLOWED_MINUTES_BY_CARD[cardType]?.includes(tg.minutes);
    });
    return (
        <div
            style={{
                padding: "10px 30px",
                display: "flex",
                alignItems: "center",
            }}
        >
            <div
                style={{
                    borderRadius: "50%",
                    backgroundColor: "transparent",
                    border: "1px solid black",
                    height: 35,
                    width: 35,
                    fontWeight: 700,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: 20,
                }}
            >
                <Icon name="fa-arrow-circle-right" />
            </div>

            {eventDetails?.suspensionTime && (
                <button
                    style={{
                        borderRadius: 5,
                        backgroundColor:
                            eventDetails?.suspensionTime?.backgroundColor ||
                            "white",
                        border: `2px solid ${eventDetails?.suspensionTime?.borderColor}`,
                        color: eventDetails?.suspensionTime?.color || "black",
                        height: 40,
                        width: "25%",
                        fontWeight: 700,
                        marginRight: 30,
                        fontSize: 13,
                    }}
                >
                    <span>{eventDetails?.suspensionTime?.name}</span>
                </button>
            )}

            {eventDetails?.suspensionTime && (
                <button
                    style={{
                        border: "none",
                        backgroundColor: "transparent",
                        fontSize: "16px",
                    }}
                    onClick={() => {
                        setEventDetails((data) => ({
                            ...data,
                            suspensionTime: null,
                            typeOfCornerGoalSelected: null,
                        }));
                        changeCallback && changeCallback();
                    }}
                >
                    X
                    <span
                        style={{
                            border: "none",
                            backgroundColor: "transparent",
                            fontSize: "16px",
                            textDecoration: "underline",
                            marginLeft: 5,
                        }}
                    >
                        Ändern
                    </span>
                </button>
            )}

            {!eventDetails?.suspensionTime && (
                <div
                    style={{
                        display: "flex",
                        width: "70%",
                    }}
                >
                    {suspensionOptions?.map((tg, index) => {
                        return (
                            <button
                                key={index}
                                style={{
                                    borderRadius: 5,
                                    backgroundColor:
                                        tg?.backgroundColor || "white",
                                    border: `2px solid ${tg?.borderColor}`,
                                    color: tg?.color || "black",
                                    height: 40,
                                    width: "45%",
                                    fontWeight: 700,
                                    marginRight: 10,
                                    fontSize: 13,
                                }}
                                onClick={() => {
                                    setEventDetails((data) => ({
                                        ...data,
                                        suspensionTime: tg,
                                    }));
                                    confirmCallback && confirmCallback();
                                }}
                            >
                                {tg?.name}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default SuspensionTime;
